import React, { Component } from 'react';
import * as bActs from '../actions/blog-actions';
import connect from "react-redux/es/connect/connect";
import { FormattedDate } from 'react-intl';
import NotFound from "../components/notfound";
import * as wConsts from "../consts/website-consts";
import SeoHeaders from "../components/seoheaders";
import Pager from "../components/pager";
import SideBanners from "../components/sidebanners";

class BlogPost extends Component {

  componentWillMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "blog" });
  }

  render() {
    let loc = typeof window === "undefined" ? "" : window.location.href;
    if (this.props.WebPage.PageLoaded && this.props.WebPage.Page.Name === "404") {
      return <NotFound />;
    }

    let blogPost = () => {
      return (
        <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
          <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
        </p>
      );
    };
    const loaded = this.props.Post.Loaded;
    const code = this.props.Post.Result.Code;
    if(loaded && code === 200) {
      const post = this.props.Post.Result.Result;

      const featuredImg = post.Image;
      let showImage = bActs.showImage(featuredImg.Width, featuredImg.Height);
      if(!this.props.WebPage.Settings.ShowFeaturedImagesInBlogPosts) {
        showImage = false;
      }

      blogPost = () => {
        return (

          <div className="blog-wrapper">
            <article className="article-item single">
              <div className="article-meta">
                <div className="postdate left"  style={{lineHeight: "22px"}}><i className="far fa-user"></i>&nbsp;{post.Author.Name}<br/><i className="far fa-clock"></i>&nbsp;<FormattedDate value={post.PublishedDate} weekday="long" day="2-digit" month="long" year="numeric"  /></div>
                {post.Categories.length>0 &&
                  <div className="tags-wrapper right">
                    <i className="fas fa-tag"></i>
                    {post.Categories.map((cv,i) => { return <span style={{margin: "2px", color: "#656669"}} key={cv.Slug}>{cv.Name}</span>})}
                  </div>
                }
              </div>

              {showImage &&
                <div className="image"><img style={{marginTop: "10px"}} src={post.Image.Url} alt={post.Title} /></div>
              }

              <div className="clear" style={{width: "100%", marginBottom: "20px"}}></div>
              {typeof window !== "undefined" &&
              <p className="blog-body" dangerouslySetInnerHTML={{__html: post.Body}}></p>
              }


            </article>
          </div>


        )
      };
    }

    return (

    <div className="">
    <SeoHeaders Position={"Top"}/>
      <div className="">
        <div className="row">
          <div className="col_80">
            <div className="white-box the-content">
              {blogPost()}
            </div>
          </div>
          <SideBanners/>
        </div>
      </div>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Post: state.Blog.BlogPages
  };
}

export default connect(mapStateToProps)(BlogPost);
